// extracted by mini-css-extract-plugin
module.exports = {"withIcon":"MessageBoxContainer-withIcon-1Nd3n","withoutIcon":"MessageBoxContainer-withoutIcon-2FFo4"};